import { useCallback } from 'react';
import PositionsAndOrdersFilterDropdown, {
	PositionsAndOrdersFilterOption,
} from '../Utils/PositionAndOrdersFiltersDropdown';
import { useTableFiltersState } from 'src/hooks/useTableFiltersState';

type OpenOrdersFiltersProps = {
	small?: boolean;
	overviewPage?: boolean;
};

export const OpenOrdersFilters = (props: OpenOrdersFiltersProps) => {
	const {
		showOnlyCurrentMarket,
		showPerpMarkets,
		showSpotMarkets,
		setShowPerpMarkets,
		setShowOnlyCurrentMarket,
		setShowSpotMarkets,
	} = useTableFiltersState(props);
	const orderFiltersOptions: PositionsAndOrdersFilterOption[] = [
		{
			type: 'perpMarkets',
			label: 'Perp Orders',
			value: showOnlyCurrentMarket ? false : (showPerpMarkets ?? false),
		},
		{
			type: 'spotMarkets',
			label: 'Spot Orders',
			value: showOnlyCurrentMarket ? false : (showSpotMarkets ?? false),
		},
	];

	if (!props.overviewPage) {
		orderFiltersOptions.push({
			type: 'selectedMarketOnly',
			label: 'Only selected market',
			value: showOnlyCurrentMarket ?? false,
		});
	}

	const handlechangeFilters = useCallback(
		(filterOption: PositionsAndOrdersFilterOption) => {
			if (!filterOption) return;

			switch (filterOption.type) {
				case 'perpMarkets':
					setShowPerpMarkets(filterOption.value);
					break;
				case 'spotMarkets':
					setShowSpotMarkets(filterOption.value);
					break;
				case 'selectedMarketOnly':
					setShowOnlyCurrentMarket(filterOption.value);
					break;
			}
		},
		[setShowPerpMarkets, setShowSpotMarkets, setShowOnlyCurrentMarket]
	);

	return (
		<PositionsAndOrdersFilterDropdown
			filterOptions={orderFiltersOptions}
			onChange={handlechangeFilters}
		/>
	);
};
